// Mutations
export const SET_COUNTRIES = 'SET_COUNTRIES';

// Actions
export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
